import { BASE_URL } from 'constants/api';
import { createPostAPI } from '@cuemath/rest-api';

const { usePost: useAddPauseUnitsForTeacherPost } = createPostAPI({
  getURL: (_, { teacherId }) => `${BASE_URL}/leaves/teachers/${teacherId}/grant/`,
});

const { usePost: useAddPauseUnitsForStudentPost } = createPostAPI({
  getURL: (_, { studentId }) => `${BASE_URL}/leaves/students/${studentId}/grant/`,
});

export { useAddPauseUnitsForTeacherPost, useAddPauseUnitsForStudentPost };
